import { useCallback, useEffect, useRef } from "react";

/** Intervalo mínimo entre consultas automáticas (evita rajadas de request). */
export const NOTIFICACOES_MIN_INTERVALO_MS = 30_000;
/** Intervalo do polling em segundo plano. */
export const NOTIFICACOES_POLL_INTERVALO_MS = 120_000;

/**
 * Polling de notificações com pausa quando a aba está oculta.
 * Não reinicia/limpa a cada troca de rota — só no mount/unmount.
 */
export default function useNotificacoesPolling({
  enabled,
  consultarNotificacoes,
}) {
  const timerRef = useRef(null);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const tick = useCallback(() => {
    if (typeof document !== "undefined" && document.hidden) return;
    consultarNotificacoes();
  }, [consultarNotificacoes]);

  useEffect(() => {
    if (!enabled) {
      clearTimer();
      return undefined;
    }

    consultarNotificacoes({ force: true });
    clearTimer();
    timerRef.current = setInterval(tick, NOTIFICACOES_POLL_INTERVALO_MS);

    const onVisibility = () => {
      if (!document.hidden) {
        consultarNotificacoes();
      }
    };

    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      clearTimer();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [enabled, consultarNotificacoes, clearTimer, tick]);
}
